module.exports = __webpack_public_path__ + "media/tang_4.2c71727e.mp4";